import {getAllchild} from '@/api/maintain/config/index.js'
import * as lib from '@/util/lib.js'
export let mixin = {
  props: {
    requestData: {
      type: Object
    },
    baseInfo: {
      type: Object
    }
  },
  data () {
    return {
      requestParams: {
        'order.direction': 'ASC',
        'order.property': 'name'
      }
    }
  },
  methods: {
    clickName (item) {
      this.$emit('changetree', item)
    },
    getList () {
      // this.$parent.setData(true, [])
      this.requestParams.page = this.pagination.request.page
      this.requestParams.size = this.pagination.request.size
      getAllchild(this.baseInfo.id, this.requestData, this.requestParams).then(data => {
        this.data = data.data
        this.pagination = {...this.pagination, total: data.total}
        this.$nextTick(() => {
          this.$parent.setData(false, this.data)
          lib.setScroll($(this.$el))
        })
      }).catch(error => {
        this.$notify(error)
        this.$parent.setData(true, [])
      })
    }
  },
  mounted () {
  }
}



// WEBPACK FOOTER //
// ./src/view/maintain/light/plant/part/commonMethds.js